import PropTypes from 'prop-types'
import R from 'ramda'
import _Modal from 'styled-react-modal'
import styled from 'styled-components'
import { layout } from 'styled-system'

import { Box, Heading, IconButton, media } from '@redriverpress/system'

export const StyledModal = _Modal.styled`
  background: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.radii.rounded};
  box-shadow: 0 3px 18px rgba(0,0,0,0.333);
  display: block;
  margin: ${props => props.theme.space[3]};
  position: relative;
  max-height: 80vh;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  ${media.md`
    margin: ${props => props.theme.space[4]} auto;
    max-width: 60ch;
  `}
  ${layout}
`

StyledModal.displayName = 'StyledModal'

const TitleBox = styled(Box)`
  border-top-left-radius: ${props => props.theme.radii.rounded};
  border-top-right-radius: ${props => props.theme.radii.rounded};
`

export default function Modal({ children, title, isOpen, onClose, ...props }) {
  return (
    <StyledModal
      isOpen={isOpen}
      allowScroll={false}
      onEscapeKeydown={onClose}
      onBackgroundClick={onClose}
      {...props}
    >
      {title && (
        <TitleBox
          alignItems='center'
          bg='gray100'
          boxShadow={1}
          display='flex'
          py={3}
          px={[3, null, 4]}
          position='sticky'
          top={0}
          zIndex={3}
        >
          <Box flex={1}>
            {R.is(String, title) ? (
              <Heading as='h5' mb={0}>
                {title}
              </Heading>
            ) : (
              title
            )}
          </Box>
          <Box alignSelf='flex-end'>
            <IconButton mr={[-2, null, -3]} onClick={onClose} />
          </Box>
        </TitleBox>
      )}
      <Box p={[3, null, 4]}>{children}</Box>
    </StyledModal>
  )
}

Modal.defaultProps = {
  title: null,
}

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClose: PropTypes.func.isRequired,
}
